// removed by extract-text-webpack-plugin
module.exports = {"content":"bEE_bumgFfr1Rocor_9kj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconLabel/style.scss
// module id = 2134
// module chunks = 1